<template>
  <span>
  <button @click="viewOptions()" title="Options" class="view-options-button gds-button gds-compact gds-button-outline">
    <svg class="gds-icon shift-left">
      <use xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-settings" />
    </svg>
    <span>{{ viewOptionsLabel }}</span>
  </button>
  </span>
</template>

<script>
export default {
  name: "ButtonViewOptions",
  props: {
    viewOptions: Function,
    viewOptionsLabel: {
      type: String,
      default: "View Options"
    },
  }
};
</script>

<style scoped>
</style>